document.addEventListener('DOMContentLoaded', function () {

  const toggles = document.querySelectorAll(".mobile-canvas .has-dropdown > a");

  toggles.forEach(toggle => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();

      const parent = this.parentElement;

      // Close other open menus (optional)
      document.querySelectorAll(".mobile-canvas .has-dropdown")
        .forEach(item => {
          if (item !== parent) {
            item.classList.remove("active");
          }
        });

      // Toggle current
      parent.classList.toggle("active");
    });
  });

  document.addEventListener('click', function (e) {
    const toggleBtn = e.target.closest('[data-handle="toggle"]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      const target = toggleBtn.getAttribute('data-target');
      const canvas = document.querySelector('[data-target-element="' + target + '"]');
      if (!canvas) return;
      canvas.classList.toggle('active');
      return;
    }

    if (e.target.closest('.canvas-close')) {
      const canvas = e.target.closest('.mobile-canvas');
      if (canvas) canvas.classList.remove('active');
      return;
    }

    document.querySelectorAll('.mobile-canvas.active').forEach(canvas => {
      const wrapper = canvas.querySelector('.canvas-wrapper');
      if (wrapper && !wrapper.contains(e.target)) {
        canvas.classList.remove('active');
      }
    });
  });

  // HEADER HEIGHT -> BODY VAR
  var header = document.querySelector('.custom-header-section');
  var body = document.body;

  if (!header || !body) return;

  function setHeaderHeight() {
    body.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  const slider = document.querySelector('.v-slider');
  const slidesWrap = document.getElementById('vSlides');

  if (!slider || !slidesWrap) return;

  const slides = slidesWrap.querySelectorAll('.v-slide');
  const dots = document.querySelectorAll('.dot');
  const bgHolder = document.querySelector('.bg-image-active');

  let slideHeight = parseFloat(
    getComputedStyle(slider).getPropertyValue('--slide-height')
  );

  let currentIndex = 0;
  let autoplayDelay = 5000;
  let autoplayTimer;

  /* ---------------------------
    ACTIVE SLIDE
  ----------------------------*/
  function setActiveSlide(index) {

    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;

    currentIndex = index;

    slidesWrap.style.transform = `translateY(-${index * slideHeight}px)`;

    slides.forEach(s => s.classList.remove('active'));
    dots.forEach(d => d.classList.remove('active'));

    slides[index]?.classList.add('active');
    dots[index]?.classList.add('active');

    const bgURL = slides[index]?.dataset.bg;

    if (bgURL) {
      bgHolder.style.opacity = '0';

      requestAnimationFrame(() => {
        bgHolder.style.backgroundImage = `url("${bgURL}")`;
        bgHolder.style.opacity = '1';
      });
    } else {
      bgHolder.style.backgroundImage = 'none';
    }
  }

  /* ---------------------------
    AUTOPLAY
  ----------------------------*/
  function startAutoplay() {

    autoplayTimer = setInterval(() => {
      setActiveSlide(currentIndex + 1);
    }, autoplayDelay);

  }

  function stopAutoplay() {
    clearInterval(autoplayTimer);
  }

  /* ---------------------------
    DOT CLICK
  ----------------------------*/
  dots.forEach(dot => {

    dot.addEventListener('click', () => {
      stopAutoplay();
      setActiveSlide(Number(dot.dataset.index));
      startAutoplay();
    });

  });


  /* ---------------------------
    DRAG / SWIPE
  ----------------------------*/
  let startY = 0;
  let isDragging = false;

  function dragStart(e) {

    isDragging = true;
    stopAutoplay();

    startY = e.type.includes('mouse')
      ? e.pageY
      : e.touches[0].clientY;
  }

  function dragMove(e) {

    if (!isDragging) return;

    const currentY = e.type.includes('mouse')
      ? e.pageY
      : e.touches[0].clientY;

    const diff = startY - currentY;

    if (Math.abs(diff) > 80) {

      if (diff > 0) {
        setActiveSlide(currentIndex + 1);
      } else {
        setActiveSlide(currentIndex - 1);
      }

      isDragging = false;
      startAutoplay();
    }
  }

  function dragEnd() {
    isDragging = false;
  }

  /* Mouse */
  slider.addEventListener('mousedown', dragStart);
  slider.addEventListener('mousemove', dragMove);
  slider.addEventListener('mouseup', dragEnd);
  slider.addEventListener('mouseleave', dragEnd);

  /* Touch */
  slider.addEventListener('touchstart', dragStart);
  slider.addEventListener('touchmove', dragMove);
  slider.addEventListener('touchend', dragEnd);


  /* ---------------------------
    INIT
  ----------------------------*/
  window.addEventListener('load', () => {

    setActiveSlide(0);
    startAutoplay();

  });


  // === Dual Product Slider JS
  document.querySelectorAll('[data-dual-slider]').forEach(function (slider) {
    var dotsWrap = slider.nextElementSibling;
    if (!dotsWrap || !dotsWrap.hasAttribute('data-dual-dots')) return;

    function getPageCount() {
      return Math.ceil(slider.scrollWidth / slider.clientWidth);
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      var pages = getPageCount();

      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('span');
        if (i === 0) dot.classList.add('active');
        dot.dataset.index = i;

        dot.addEventListener('click', function () {
          var index = parseInt(this.dataset.index, 10);
          slider.scrollTo({
            left: index * slider.clientWidth,
            behavior: 'smooth'
          });
        });

        dotsWrap.appendChild(dot);
      }
    }

    function updateActiveDot() {
      var index = Math.round(slider.scrollLeft / slider.clientWidth);
      var dots = dotsWrap.children;

      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('active', i === index);
      }
    }

    buildDots();
    updateActiveDot();

    slider.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateActiveDot);
    });

    window.addEventListener('resize', function () {
      buildDots();
      updateActiveDot();
    });
  });
});
document.addEventListener('DOMContentLoaded', function() {
  var select = document.querySelector('[name="checkout[shipping_address][country]"]');
  if (select) {
    Array.from(select.options).forEach(function(opt) {
      if (opt.value !== 'Switzerland' && opt.value !== 'Liechtenstein' && opt.value !== '') {
        opt.remove();
      }
    });
  }
});